import apisauce from 'apisauce';
import Global from '../lib/Global';
import env from 'react-dotenv';
import storage from '../store';
import AuthActions from '../redux/AuthRedux';

const { store } = storage;

console.log('REACT_APP_API_URL:', env.REACT_APP_API_URL);

const ENDPOINT_AJAX = '/ajax/v1';
const ENDPOINT_AUTH = '/auth';
const ENDPOINT_THIRD_PARTY_v2 = '/cmanager/v2/third-party';

// Ajax endpoints
const ENDPOINT_HUBS = '/hubs';
const ENDPOINT_GROUPS = '/groups';
const ENDPOINT_COMMANDS = '/commands';
const ENDPOINT_ARMING = '/arming';
const ENDPOINT_DEVICES = '/devices';
const ENDPOINT_ROOMS = '/rooms';
const ENDPOINT_LOGS = '/logs';

// authentication endpoints
const ENDPOINT_LOGIN = '/login';
const ENDPOINT_RESET = '/reset';
const ENDPOINT_SECURE_LOGIN = '/secure-login';

// third party endpoints
const ENDPOINT_ACCESS_LEVEL = '/accesslevel';
const ENDPOINT_AUDIT = '/audit';
const ENDPOINT_AVAILABLE = '/available';
const ENDPOINT_COMMAND = '/command';
const ENDPOINT_CONTROLLER = '/controller';
const ENDPOINT_CONTROLLERS = '/controllers';
const ENDPOINT_CUSTOMER = '/customer';
const ENDPOINT_DISTRIBUTOR = '/distributor';
const ENDPOINT_DOOR = '/door';
const ENDPOINT_DOOR_CONTROL = '/doorcontrol';
const ENDPOINT_DOOR_CONTROL_ID = '/doorControlId';
const ENDPOINT_DOOR_SCHEDULE = '/doorschedule';
const ENDPOINT_EVENT_LOG = '/eventlog';
const ENDPOINT_FILES = '/files';
const ENDPOINT_FILTERED = '/filtered';
const ENDPOINT_NAME = '/name';
const ENDPOINT_PERSON = '/person';
const ENDPOINT_REPORT_MODEL = '/reportmodel';
const ENDPOINT_SETTINGS = '/settings';
const ENDPOINT_SCHEDULE = '/schedule';
const ENDPOINT_SITE = '/site';
const ENDPOINT_SOFTWARE_UPDATE = '/software/update';
const ENDPOINT_TAG = '/tag';
const ENDPOINT_TAG_TYPE = '/tagtype';
const ENDPOINT_USER = '/user';

const createApi = (baseURL = env.REACT_APP_API_URL) => {
  const api = apisauce.create({
    baseURL,
    headers: {
      'Cache-Control': 'no-cache',
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    timeout: 20000,
  });

  api.addRequestTransform((request) => {
    if (!request.url.includes(ENDPOINT_LOGIN) && !request.url.includes(ENDPOINT_SECURE_LOGIN)) {
      const accessToken = store.getState().auth.token || Global.api.accessToken;
      request.headers = {
        ...request.headers,
        Authorization: `Bearer ${accessToken}`,
      };
    }
  });

  api.addRequestTransform((request) => {
    if (request.url.includes(ENDPOINT_FILES) && request.method === 'post') {
      const file = request.data;
      request.headers = {
        ...request.headers,
        'Content-Type': 'multipart/form-data',
      };
      let formData = new FormData();
      formData.append('file', file);
      console.log('formData:', formData);
      request.data = formData;
    }
  });

  // ajax
  const loginAjax = (customerId) =>
    api.post(`${ENDPOINT_AJAX}${ENDPOINT_LOGIN}`, null, {
      params: {
        cid: customerId,
      },
    });
  const getHubs = (customerId, userId) =>
    api.get(`${ENDPOINT_AJAX}${ENDPOINT_USER}/${userId}${ENDPOINT_HUBS}`, { cid: customerId });
  const getHubDetails = (customerId, userId, hubId) =>
    api.get(`${ENDPOINT_AJAX}${ENDPOINT_USER}/${userId}${ENDPOINT_HUBS}/${hubId}`, { cid: customerId });
  const getGroups = (customerId, userId, hubId) =>
    api.get(`${ENDPOINT_AJAX}${ENDPOINT_USER}/${userId}${ENDPOINT_HUBS}/${hubId}${ENDPOINT_GROUPS}`, {
      cid: customerId,
      p: 1, //TODO verify if necessary
    });
  const armHub = (customerId, userId, hubId, command) =>
    api.put(
      `${ENDPOINT_AJAX}${ENDPOINT_USER}/${userId}${ENDPOINT_HUBS}/${hubId}${ENDPOINT_COMMANDS}${ENDPOINT_ARMING}`,
      { command, ignoreProblems: true },
      {
        params: {
          cid: customerId,
        },
      },
    );
  const armGroup = (customerId, userId, hubId, groupId, command) =>
    api.put(
      `${ENDPOINT_AJAX}${ENDPOINT_USER}/${userId}${ENDPOINT_HUBS}/${hubId}${ENDPOINT_GROUPS}/${groupId}${ENDPOINT_COMMANDS}${ENDPOINT_ARMING}`,
      { command, ignoreProblems: true },
      {
        params: {
          cid: customerId,
        },
      },
    );
  const getDevices = (customerId, userId, hubId) =>
    api.get(`${ENDPOINT_AJAX}${ENDPOINT_USER}/${userId}${ENDPOINT_HUBS}/${hubId}${ENDPOINT_DEVICES}`, {
      cid: customerId,
    });
  const getRooms = (customerId, userId, hubId) =>
    api.get(`${ENDPOINT_AJAX}${ENDPOINT_USER}/${userId}${ENDPOINT_HUBS}/${hubId}${ENDPOINT_ROOMS}`, {
      cid: customerId,
    });
  const getLogs = (customerId, userId, hubId, pageNumber) =>
    api.get(`${ENDPOINT_AJAX}${ENDPOINT_USER}/${userId}${ENDPOINT_HUBS}/${hubId}${ENDPOINT_LOGS}`, {
      cid: customerId,
      p: pageNumber,
    });
  const getAjaxAccessLevelLinks = (accessLevelId) =>
    api.get(`${ENDPOINT_AJAX}${ENDPOINT_ACCESS_LEVEL}/${accessLevelId}`);
  const updateAjaxAccessLevelLinks = (ajaxAccessLevelLinks) =>
    api.post(`${ENDPOINT_AJAX}${ENDPOINT_ACCESS_LEVEL}`, ajaxAccessLevelLinks);
  const deleteAjaxAccessLevelLink = (ajaxAccessLevelLinkId) =>
    api.delete(`${ENDPOINT_AJAX}${ENDPOINT_ACCESS_LEVEL}/${ajaxAccessLevelLinkId}`);

  // authentication
  const login = (username, password) =>
    api.post(`${ENDPOINT_AUTH}${ENDPOINT_LOGIN}`, {
      username,
      password,
    });
  const sendResetPasswordEmail = (username, url) => api.post(`${ENDPOINT_AUTH}${ENDPOINT_RESET}`, { username, url });
  const resetPassword = (params) => api.put(`${ENDPOINT_AUTH}${ENDPOINT_RESET}`, params);
  const twoFactorAuthenticate = (params) => api.post(`${ENDPOINT_AUTH}${ENDPOINT_SECURE_LOGIN}`, params);

  // third party endpoints are sorted alphabetically by category, ex. access levels, customer, ...users

  // access levels
  const getAccessLevels = (customerId, pageParams) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_ACCESS_LEVEL}/${customerId}`, pageParams);
  const createAccessLevel = (accessLevelInfos) =>
    api.post(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_ACCESS_LEVEL}`, accessLevelInfos);
  const editAccessLevel = (accessLevelInfos) =>
    api.put(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_ACCESS_LEVEL}`, accessLevelInfos);
  const deleteAccessLevel = (accessLevelId) =>
    api.delete(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_ACCESS_LEVEL}/${accessLevelId}`);
  // access levels controllers
  const getAccessLevelControllers = (accessLevelId) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_ACCESS_LEVEL}/${accessLevelId}${ENDPOINT_CONTROLLERS}`);
  const addControllersToAccessLevel = (accessLevelId, controllers) =>
    api.post(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_ACCESS_LEVEL}/${accessLevelId}${ENDPOINT_CONTROLLERS}`, controllers);
  const deleteAccessLevelControllers = (accessLevelId, controllers) =>
    api.delete(
      `${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_ACCESS_LEVEL}/${accessLevelId}${ENDPOINT_CONTROLLERS}`,
      {},
      { data: controllers },
    );
  // audit logs
  const getAuditLogs = (customerId, params) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_AUDIT}/${customerId}`, params);

  // controllers
  const getControllers = (pageParams) => api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_CONTROLLERS}`, pageParams);
  const getControllerDetails = (controllerId) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_CONTROLLERS}/${controllerId}`);
  const editController = (controllerId, controllerInfos) =>
    api.put(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_CONTROLLERS}/${controllerId}${ENDPOINT_NAME}`, controllerInfos);
  const editControllerSettings = (controllerId, controllerSettings) =>
    api.put(
      `${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_CONTROLLERS}/${controllerId}${ENDPOINT_SETTINGS}`,
      controllerSettings,
    );
  const deleteController = (controllerId) =>
    api.delete(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_CONTROLLERS}/${controllerId}`);
  const uploadFile = (file) =>
    api.post(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_FILES}`, file, {
      params: {
        value: 'CONTROLLER',
      },
    });
  const updateControllers = (body) =>
    api.post(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_CONTROLLERS}${ENDPOINT_SOFTWARE_UPDATE}`, body);

  // customer
  const getCustomers = () => api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_CUSTOMER}`);
  const deleteCustomer = (customerId) => api.delete(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_CUSTOMER}/${customerId}`);
  const createCustomer = (customerInfos) => api.post(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_CUSTOMER}`, customerInfos);
  const editCustomer = (customerInfos) =>
    api.put(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_CUSTOMER}/${customerInfos?.customerId}`, customerInfos);
  const getCustomersByDistributor = (distributorId, pageParams) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_CUSTOMER}/${distributorId}`, pageParams);
  // door control
  const getDoorControls = (pageParams, customerId) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_DOOR_CONTROL}/${customerId}`, pageParams);
  const createDoorControl = (doorControlInfos) =>
    api.post(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_DOOR_CONTROL}`, doorControlInfos);
  const editDoorControl = (doorControlInfos) =>
    api.put(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_DOOR_CONTROL}`, doorControlInfos);
  const deleteDoorControl = (doorControlId) =>
    api.delete(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_DOOR_CONTROL}/${doorControlId}`);
  const getAvailableDoorControlsControllers = (pageParams, customerId) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_CONTROLLERS}${ENDPOINT_AVAILABLE}/${customerId}`, pageParams);
  const getDoorControlControllers = (doorControlId, pageParams) =>
    api.get(
      `${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_CONTROLLERS}/${doorControlId}${ENDPOINT_DOOR_CONTROL_ID}`,
      pageParams,
    );
  const addDoorControlControllers = (doorControlId, controllers) =>
    api.post(
      `${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_DOOR_CONTROL}${ENDPOINT_DOOR_SCHEDULE}/${doorControlId}`,
      controllers,
    );
  const editDoorControlControllers = (doorControlId, controllers) =>
    api.put(
      `${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_DOOR_CONTROL}${ENDPOINT_DOOR_SCHEDULE}/${doorControlId}`,
      controllers,
    );
  const deleteDoorControlControllers = (doorControlId, controllers) =>
    api.delete(
      `${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_DOOR_CONTROL}${ENDPOINT_DOOR_SCHEDULE}/${doorControlId}`,
      {},
      { data: controllers },
    );
  // distributor
  const getDistributorInfo = (distributorId) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_DISTRIBUTOR}/${distributorId}`);
  const getDistributorsList = (pageParams) => api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_DISTRIBUTOR}`, pageParams);
  // door manual opening
  const openDoor = (controllerId, customerId) =>
    api.post(
      `${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_COMMAND}${ENDPOINT_DOOR}/${controllerId}${ENDPOINT_CUSTOMER}/${customerId}`,
    );
  const checkDoorStatus = (controllerId, commandId) =>
    api.get(
      `${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_COMMAND}${ENDPOINT_DOOR}/${controllerId}${ENDPOINT_COMMAND}/${commandId}`,
    );
  // events reports / reports models
  const getReportModels = (pageParams) => api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_REPORT_MODEL}`, pageParams);
  const createReportModel = (reportInfos) =>
    api.post(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_REPORT_MODEL}`, reportInfos);
  const editReportModel = (reportInfos) => api.put(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_REPORT_MODEL}`, reportInfos);
  const deleteReportModel = (reportModelId) =>
    api.delete(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_REPORT_MODEL}/${reportModelId}`);
  const getEventReport = (customerId, filters, params) =>
    api.post(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_EVENT_LOG}${ENDPOINT_FILTERED}/${customerId}`, filters, { params });
  // person count
  const getPersonCount = (customerId, sites) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_EVENT_LOG}${ENDPOINT_CUSTOMER}/${customerId}`, { sites: sites + '' });
  // persons
  const getPersons = (customerId, pageParams) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_PERSON}/${customerId}`, pageParams);
  const getPersonDetails = (personId, customerId) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_PERSON}/${personId}/${customerId}`);
  const createPerson = (personInfos) => api.post(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_PERSON}`, personInfos);
  const editPerson = (personInfos) => api.put(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_PERSON}`, personInfos);
  const deletePerson = (personId, customerId) =>
    api.delete(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_PERSON}/${personId}/${customerId}`, { status: 'STATUS_REMOVED' });
  // schedules
  const getSchedules = (customerId, pageParams) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_SCHEDULE}/${customerId}`, pageParams);
  const createSchedule = (scheduleInfos) => api.post(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_SCHEDULE}`, scheduleInfos);
  const editSchedule = (scheduleInfos) => api.put(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_SCHEDULE}`, scheduleInfos);
  const deleteSchedule = (scheduleNameId) =>
    api.delete(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_SCHEDULE}/${scheduleNameId}`);
  // sites
  const getSites = (customerId, pageParams) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_SITE}/${customerId}`, pageParams);
  const createSite = (siteInfos) => api.post(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_SITE}`, siteInfos);
  const editSite = (siteInfos) => api.put(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_SITE}`, siteInfos);
  const deleteSite = (siteId) => api.delete(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_SITE}/${siteId}`);
  const getSiteControllers = (siteId) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_SITE}/${siteId}${ENDPOINT_CONTROLLER}`);
  const deleteSiteController = (siteId, data) =>
    api.delete(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_SITE}/${siteId}${ENDPOINT_CONTROLLER}`, {}, { data });
  const getSiteAvailableControllers = (pageParams, customerId) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_CONTROLLERS}${ENDPOINT_SITE}/${customerId}`, pageParams);
  const getCustomerControllers = (customerId, pageParams) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_CONTROLLERS}${ENDPOINT_CUSTOMER}/${customerId}`, pageParams);
  const addControllerToSite = (siteId, data, customerId, distributorId) =>
    api.post(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_SITE}/${siteId}${ENDPOINT_CONTROLLER}`, data, {
      params: { customerId, distributorId },
    });
  // tags and tag types
  const getPersonTags = (personId, customerId, getTagsParams) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_TAG}${ENDPOINT_PERSON}/${personId}/${customerId}`, getTagsParams);
  const createPersonTag = (tagInfos, type) =>
    api.post(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_TAG}${ENDPOINT_PERSON}`, tagInfos, { params: { type } });
  const editPersonTag = (tagId, tagInfos) => api.put(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_TAG}/${tagId}`, tagInfos);
  const deletePersonTag = (tagId) => api.delete(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_TAG}${ENDPOINT_PERSON}/${tagId}`);
  const getTagTypes = (customerId, pageParams) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_TAG}${ENDPOINT_TAG_TYPE}/${customerId}`, pageParams);
  const createTagType = (tagTypeInfos) =>
    api.post(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_TAG}${ENDPOINT_TAG_TYPE}`, tagTypeInfos);
  const editTagType = (tagTypeInfos) =>
    api.put(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_TAG}${ENDPOINT_TAG_TYPE}`, tagTypeInfos);
  const deleteTagType = (tagTypeId) =>
    api.delete(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_TAG}${ENDPOINT_TAG_TYPE}/${tagTypeId}`);
  // users
  const getUsers = (customerId, pageParams) =>
    api.get(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_USER}/${customerId}`, pageParams);
  const createUser = (userInfos, url) =>
    api.post(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_USER}`, userInfos, { params: { url } });
  const editUser = (userInfos) => api.put(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_USER}`, userInfos);
  const deleteUser = (username) =>
    api.delete(`${ENDPOINT_THIRD_PARTY_v2}${ENDPOINT_USER}/${username}`, { status: 'STATUS_REMOVED' });

  const checkAuth = (request) => {
    if (request.status === 401) {
      store.dispatch(AuthActions.logout());
    }
  };

  return {
    loginAjax,
    getHubs,
    getHubDetails,
    getGroups,
    armHub,
    armGroup,
    getDevices,
    getRooms,
    getLogs,
    getAjaxAccessLevelLinks,
    updateAjaxAccessLevelLinks,
    deleteAjaxAccessLevelLink,
    checkAuth,
    login,
    sendResetPasswordEmail,
    resetPassword,
    twoFactorAuthenticate,
    getAccessLevels,
    getAuditLogs,
    createAccessLevel,
    editAccessLevel,
    deleteAccessLevel,
    getAccessLevelControllers,
    addControllersToAccessLevel,
    deleteAccessLevelControllers,
    getControllers,
    getControllerDetails,
    editController,
    editControllerSettings,
    deleteController,
    uploadFile,
    updateControllers,
    getDoorControls,
    createDoorControl,
    editDoorControl,
    deleteDoorControl,
    getAvailableDoorControlsControllers,
    getDoorControlControllers,
    addDoorControlControllers,
    editDoorControlControllers,
    deleteDoorControlControllers,
    getDistributorInfo,
    getDistributorsList,
    getCustomers,
    createCustomer,
    editCustomer,
    deleteCustomer,
    getCustomersByDistributor,
    getReportModels,
    createReportModel,
    editReportModel,
    deleteReportModel,
    getEventReport,
    getPersonCount,
    getPersons,
    getPersonDetails,
    createPerson,
    editPerson,
    deletePerson,
    getPersonTags,
    createPersonTag,
    editPersonTag,
    deletePersonTag,
    getTagTypes,
    createTagType,
    editTagType,
    deleteTagType,
    getSchedules,
    createSchedule,
    editSchedule,
    deleteSchedule,
    getSites,
    createSite,
    editSite,
    deleteSite,
    getSiteControllers,
    deleteSiteController,
    addControllerToSite,
    getCustomerControllers,
    getSiteAvailableControllers,
    getUsers,
    createUser,
    editUser,
    deleteUser,
    openDoor,
    checkDoorStatus,
  };
};

export default {
  createApi,
};
